import { Divider, List } from '@mui/material';
import React, { useRef, useState } from 'react';
import logoAiVoice from '@src/assets/logo/logo-AiVoice-new.svg';
import { StyledSidebarNew } from './index.style';

import UserInfo from '../UserInfo';
import VoucherAds from '../VoucherAds';
import ProductSwitcher from '../ProductSwitcher';

const LargeSidebar = ({
  createLinks,
  sidebarRoute,
  ipLocation,
  handleCloseSidebar,
  // renderSubMenuSupport,
  isExpiredPackage,
  vouchers,
  showAutoRenewalBanner,
  useHeaderBanner,
  headerVoucher,

  voucherSidebar,
}) => {
  const sidebarBodyRef = useRef(null);
  const [showScrollbar, setShowScrollbar] = useState(false);

  const renderSideBarItems = (props) => (
    <div
      ref={sidebarBodyRef}
      onMouseEnter={() => setShowScrollbar(true)}
      onMouseLeave={() => setShowScrollbar(false)}
      className={`sidebar-wrapper ${
        showScrollbar ? 'small-scrollbar' : 'hidden-scrollbar'
      } `}
    >
      <ProductSwitcher expanded />
      <List className="list" style={{ paddingBottom: '0px' }}>
        {createLinks(sidebarRoute, props)}
      </List>
    </div>
  );

  return (
    <StyledSidebarNew
      useHeaderBanner={useHeaderBanner}
      headerVoucher={headerVoucher}
    >
      <div className="brand">
        <img
          src={logoAiVoice}
          alt="vbee tts logo"
          className="logo-img"
          width={108}
        />
      </div>
      <Divider />
      {renderSideBarItems()}

      <VoucherAds
        isExpiredPackage={isExpiredPackage}
        showAutoRenewalBanner={showAutoRenewalBanner}
        vouchers={vouchers}
        voucherSidebar={voucherSidebar}
      />

      <Divider sx={{ marginTop: '12px' }} />
      <UserInfo
        handleCloseSidebar={handleCloseSidebar}
        ipLocation={ipLocation}
      />
    </StyledSidebarNew>
  );
};

export default LargeSidebar;
